export default {
  root: {
    backgroundColor: '#fff',
    zIndex: -1,
    position: 'fixed',
    inset: 0,
    '-webkit-tap-highlight-color': 'transparent',
  },
};
